import React, { useEffect, useState } from 'react';
import * as Sentry from "@sentry/react";

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import { LayoutProps, Menu, Notifications, useGlobalState } from 'piral';
import {
    chartsCustomizations,
    dataGridCustomizations,
    datePickersCustomizations,
    treeViewCustomizations,
} from './theme/customizations';
import { alpha } from '@mui/material/styles';
import { FliptProvider } from '@flipt-io/flipt-client-react';

import AppTheme from './theme/AppTheme';
import { Box, CssBaseline, IconButton, Stack, StyledEngineProvider } from '@mui/material';
import SideMenu from './components/SideMenu';
import AppNavbar from './components/AppNavbar';
import Header from './components/Header';
import Settings from './pages/Settings';

const xThemeComponents = {
    ...chartsCustomizations,
    ...dataGridCustomizations,
    ...datePickersCustomizations,
    ...treeViewCustomizations,
};

const app: React.FC<LayoutProps> = ({ children }) => {
    const mode = useGlobalState(s => s.theme || 'light'); // <-- get from Piral global state
    const [open, setOpen] = useState(false);
    const drawerWidth = 240;
    const closedDrawerWidth = 65;

    return (
        <FliptProvider
            namespace="app-hub"
            options={{
                url: 'https://cannon-feature-flag.azurewebsites.net',
                authentication: {
                    clientToken: 'Ax6uUyBX-ZblqMYOoT52BHwNGZBgHvQtpeeFQuOaqak='// 'ow0Hi7GIhqaq8u2ybIn22EQaF_X9cDkn9WmdzQrLUko='
                }
                // Add other configuration options as needed
            }}
        >
            <StyledEngineProvider injectFirst>
                <AppTheme themeComponents={xThemeComponents}>
                    <CssBaseline enableColorScheme />
                    <Box sx={{ display: 'flex', height: '100%' }}>
                        <SideMenu open={open} setOpen={setOpen} drawerWidth={drawerWidth} closedDrawerWidth={closedDrawerWidth} />
                        <AppNavbar />
                            <Box
                                component="main"
                                sx={{
                                flexGrow: 1,
                                transition: (theme) =>
                                    theme.transitions.create('margin', {
                                    easing: theme.transitions.easing.sharp,
                                    duration: theme.transitions.duration.standard,
                                    }),
                                p: 3,
                                }}
                            >
                            <Stack
                                spacing={2}
                                sx={{
                                    alignItems: 'center',
                                    mx: 3,
                                    pb: 5,
                                    mt: { xs: 8, md: 0 },
                                }}
                            >
                                <Header />
                                    <Routes>
                                        <Route path="/settings" element={<Settings />}>
                                        </Route>
                                        <Route path="/*" element={children}>
                                            {/* {children}/ */}
                                        </Route>
                                    </Routes>
                                {/* {children} */}
                                <Notifications />
                            </Stack>
                        </Box>
                    </Box>
                </AppTheme>
            </StyledEngineProvider>
        </FliptProvider>
    )
};

const MainPage = (children) => {
    return (
         {children}
    )
}

const AdminPage = () => {
    return (
        <Box sx={{ p: 2 }}>
            <h1>Admin Page</h1>
            <p>This is the admin page content.</p>
        </Box>
    );
}

export default Sentry.withProfiler(app);